<template>
    <v-autocomplete label="Select Package" v-model="selected" :items="items" item-text="text" @change="$emit('selected',selected.value)" return-object></v-autocomplete>
</template>

<script>
    export default {
        name: "PackageDropdown",
        data: () => ({
            selected: null,
            items: [
                {text: 'GPM Package', value: 'GPM Package'},
                {text: 'Concentrate Package', value: 'Concentrate Package'},
                {text: 'Other Material', value: 'Other Material'},
                {text: 'EXPEDITE - 24 hour results delivery', value: 'EXPEDITE - 24 hour results delivery'},
                {text: 'EXPEDITE - 36 hour results delivery', value: 'EXPEDITE - 36 hour results delivery'},
                {text: 'i502 test + terpenes', value: 'i502 test + terpenes'},
                {text: 'i502 Test - Edibles, liquids, or topicals', value: 'i502 Test - Edibles, liquids, or topicals'},
                {text: 'i502 Test - Flower/trim/non-solvent', value: 'i502 Test - Flower/trim/non-solvent'},
                {text: 'i502 Test - Solvent Extract', value: 'i502 Test - Solvent Extract'},
                {text: 'Microbial Analysis', value: 'Microbial Analysis'},
                {text: 'Potency Analysis', value: 'Potency Analysis'},
                {text: 'Residual Solvent', value: 'Residual Solvent'},
                {text: 'Solvent-based Extract', value: 'Solvent-based Extract'},
                {text: 'Terpene Testing', value: 'Terpene Testing'},
                {text: 'Transportation - licensee to laboratory', value: 'Transportation - licensee to laboratory'},
                {text: 'Transport- no samples', value: 'Transport- no samples'},
                {text: 'Heavy Metals Screening', value: 'Heavy Metals Screening'},
                {text: 'Scientist Hours', value: 'Scientist Hours'},
                {text: 'Mycotoxin Screening', value: 'Mycotoxin Screening'},
                {text: 'Pesticide Screening', value: 'Pesticide Screening'},
                {text: 'Results Reentry', value: 'Results Reentry'},
                {text: 'Vitamin E Acetate Test', value: 'Vitamin E Acetate Test'},
                {text: 'Weekend Discount', value: 'Weekend Discount'},
            ]
        })
    }
</script>

<style scoped>

</style>

























